import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { CampaignStatus } from '@fitness-force/enum';
import { TagModule } from 'primeng/tag';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'fitness-force-campaign-status',
  templateUrl: './campaign-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TagModule, AsyncPipe]
})
export class CampaignStatusComponent  {

  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);
  readonly onAction = output<{ action: string; columnData: any; rowIndex: number }>();
  rowIndex: number = 0;
  rotateIconInactive = new BehaviorSubject<boolean>(false);
  rotateIconActive = new BehaviorSubject<boolean>(false);
  


  getMode(value: any) {
    if (!value || value == 0) return null;
    else if (Object.keys(value).length == 0) {
      return null;
    } else {
        return CampaignStatus[value];
    }
  }

  executeAction(action: string, columnData: any)
  {
    
    if(action == 'inactive')
    {
      this.rotateIconInactive.next(true);
    }
    else
    {
      this.rotateIconActive.next(true);
    }
    this.onAction.emit({ action, columnData: columnData, rowIndex: this.rowIndex });
    setTimeout(() => {
      this.rotateIconInactive.next(false);
      this.rotateIconActive.next(false);
    }, 100);
  }

  public get campaignStatus()
  {
    return CampaignStatus;
  }

}